/**
 * Extracts the most relevant error message from an error object
 * @param {Error} error - Error object
 * @param {string} defaultMessage - Default message if no error can be extracted
 * @returns {string} Extracted error message
 */
export function getErrorMessage(error, defaultMessage = "An error occurred") {
  if (error.response?.data) {
    // Look for any field that has errors (email, phone, firstName, etc.)
    const errorFields = Object.keys(error.response.data);
    for (const field of errorFields) {
      if (
        Array.isArray(error.response.data[field]) &&
        error.response.data[field].length > 0
      ) {
        return error.response.data[field][0];
      }
    }
    // If no arrays, look for message
    if (error.response.data.message) {
      return error.response.data.message;
    }
  }
  return error.message || defaultMessage;
}
